<template>
  <div>
    <page-table
      :shipmentCode="shipmentCode"
      :disabled="disabled"
      :shipmentStatus="shipmentStatus"
    />
  </div>
</template>
<script>
import PageTable from './components/table'
export default {
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    shipmentStatus: { type: String, default: '' },
  },
  components: { PageTable },
}
</script>
